export enum MediaTypeEnum {
    Link = 'link',
    Download = 'download',
    ShowImageInDialog = 'showImageInDialog',
    ShowVideoInDialog = 'ShowVideoInDialog',
    ShowAudioInDialog = 'ShowAudioInDialog',
    Slider = 'slider',
    MediaContent = 'showImageInDialog'
}